export async function promisify<T extends any>(val: T): Promise<Awaited<T>> {
  return await val
}
